import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSocketIO from "vue-socket.io";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowUp, faArrowDown, faSun, faMoon, faBackward, faBolt, faUserEdit, faUserTimes, faUserPlus
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./assets/styles/index.css";

library.add(
  faArrowUp, faArrowDown, faSun, faMoon, faBackward, faBolt, faUserEdit, faUserTimes, faUserPlus
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(require("vue-moment"));

Vue.use(new VueSocketIO({
  connection: "https://sio.roomcontrol.loit.ca",
  vuex: {
    store,
    actionPrefix: "SOCKET_",
    mutationPrefix: "SOCKET_",
  }
}));

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: "/login"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      next({
        path: "/"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$store.dispatch("refreshSession");
  }
}).$mount("#app");
